import { render } from "./Baka.vue?vue&type=template&id=b5e2d698"
import script from "./Baka.vue?vue&type=script&lang=js"
export * from "./Baka.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__